<mat-dialog-content class="customer-dialog">
  <!-- <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get">
                    <input id="search" name="search" type="text" [(ngModel)]="roomCode"
                     (change)="retriveRoomsLookup()" placeholder="Room Code" >
                    <label>                      </label>
                    <input id="search" name="search" type="text" [(ngModel)]="roomName"
                    (change)="retriveRoomsLookup()"placeholder="Room Name"  >

                </form>
            </div>
        </div>
    </div>
  </section> -->

  <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Room Code</mat-label>
      <input matInput [(ngModel)]="roomCode" (keyup)="retriveRoomsLookup()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>Room Name</mat-label>
      <input matInput [(ngModel)]="roomName" (keyup)="retriveRoomsLookup()">
    </mat-form-field>

  </div>

  <!-- <table>
    <thead>
        <tr >
            <th style="width: 30%;">Room Code</th>
            <th style="width: 100%;">Room Name</th>
            <th style="width: 20%;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let Rom of roomsList; let i = index">
            <td data-column="Room Code">{{Rom.roomCode}}</td>
            <td data-column="Room Name">{{Rom.roomName}}</td>
            <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="SelectRoom(Rom)">Select</button>
            </td>
        </tr>

    </tbody>
  </table> -->

    <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
        <th style="width: 30%;">Doctor Code</th>
        <th style="width: 100%;">Doctor Name</th>
        <th style="width: 20%;">Choose</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let Rom of roomsList; let i = index">
        <td>{{Rom.roomCode}}</td>
        <td>{{Rom.roomName}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectRoom(Rom)">{{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </mat-dialog-content>
